import React, { FC } from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import Icon from '@common/assets';
import Colors from '@domain/constant/colors';

import classNames from 'classnames/bind';
import style from './header.module.scss';
const cx = classNames.bind(style);

const Header: FC<ReactDatePickerCustomHeaderProps> = ({ date, decreaseMonth, increaseMonth }) => {
  const handlePrev = () => decreaseMonth();
  const handleNext = () => increaseMonth();

  return (
    <div className={cx('headerArea', 'day')}>
      <a role="button" onClick={handlePrev} className={cx('arrowBtn')}>
        <Icon name="arrowLeftLight" width={16} height={16} fill={Colors.C_COOL_GRAY_70} />
      </a>
      <div className={cx('date')}>{`${date.getFullYear()}년 ${date.getMonth() + 1}월`}</div>
      <a role="button" onClick={handleNext} className={cx('arrowBtn')}>
        <Icon name="arrowRightLight" width={16} height={16} fill={Colors.C_COOL_GRAY_70} />
      </a>
    </div>
  );
};
export default Header;
